import { defineAsyncComponent } from "vue";
import lodash from "lodash";
import store from "../../../../../../store";
import { conditionFormChecker, putField } from "../../../../../../utils/form";

const SendSamplingProductTable = defineAsyncComponent(() => import("../send-sampling-product-info/SendSamplingProductTable"));

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const createField = ({ props, data, key }) => {
    const { menuContext, viewOnly } = props;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}products`,
                            fetchCriteria: data.products?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly,
                            visiblePagination: false,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "SendSamplingProductTable" } })
                    );
                    return () => (
                        <SendSamplingProductTable{...componentProp}></SendSamplingProductTable>
                    )
                }
            },
        ]
    });
};
